(function () {
  'use strict';
  // The app embed has its own menu source, separate from Shopify navigation.
  var selector = '.buddha-menu-item[itemid="uf2l1"], ' +
    '.buddha-menu-item a[aria-label="Geo"], ' +
    '.buddha-menu-item a[aria-label="Olens"], ' +
    '.buddha-menu-item a[aria-label="Itzy Lens"]';
  function removeItem(item) {
    var menuItem = item.closest('li');
    if (menuItem) menuItem.remove();
  }
  function removeMenuItems(root) {
    if (root.nodeType !== 1 && root.nodeType !== 11) return;
    if (root.matches && root.matches(selector)) {
      removeItem(root);
      return;
    }
    root.querySelectorAll(selector).forEach(removeItem);
  }
  if (window.mmWireframe && typeof window.mmWireframe.html === 'string') {
    var template = document.createElement('template');
    template.innerHTML = window.mmWireframe.html;
    if (template.content.querySelector(selector)) {
      removeMenuItems(template.content);
      window.mmWireframe.html = template.innerHTML;
      window.mmNumMMI = template.content.querySelectorAll(':scope > .buddha-menu-item').length || 3;
    }
  }
  removeMenuItems(document.documentElement);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(removeMenuItems);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
}());
